import { createAction } from 'redux-actions';

const actions = {
  /**
   * [포인트] 이벤트 데이터 변경하기
   */
  SET_DATA: 'point/SET_DATA',
  setData: createAction('point/SET_DATA'),

  /**
   * [포인트 내역 리스트] 포인트 내역 리스트 요청하기
   */
  GET_POINT_LIST_REQUEST: 'point/GET_POINT_LIST_REQUEST',
  GET_POINT_LIST_SUCCESS: 'point/GET_POINT_LIST_SUCCESS',
  getPointList: createAction('point/GET_POINT_LIST_REQUEST'),

  /**
   * [포인트 랭킹] 포인트 랭킹 요청하기
   */
  GET_POINT_RANKING_REQUEST: 'point/GET_POINT_RANKING_REQUEST',
  GET_POINT_RANKING_SUCCESS: 'point/GET_POINT_RANKING_SUCCESS',
  getPointRanking: createAction('point/GET_POINT_RANKING_REQUEST'),

  /**
   * [포인트 발급] 쿠폰 발급받을 유저 리스트 요청하기
   */
  GET_GENERATE_POINT_USER_LIST_REQUEST: 'point/GET_GENERATE_POINT_USER_LIST_REQUEST',
  GET_GENERATE_POINT_USER_LIST_SUCCESS: 'point/GET_GENERATE_POINT_USER_LIST_SUCCESS',
  getGeneratePointUserList: createAction('point/GET_GENERATE_POINT_USER_LIST_REQUEST'),

  /**
   * [포인트 발급] 포인트 발급 전 준비 데이터 받아오기
   */
  GET_PREPARATION_GENERATE_POINT_REQUEST: 'point/GET_PREPARATION_GENERATE_POINT_REQUEST',
  GET_PREPARATION_GENERATE_POINT_SUCCESS: 'point/GET_PREPARATION_GENERATE_POINT_SUCCESS',
  getPreparationGeneratePoint: createAction('point/GET_PREPARATION_GENERATE_POINT_REQUEST'),

  /**
   * [포인트 log 모달] 포인트 log 요청하기
   */
  GET_POINT_LOG_REQUEST: 'point/GET_POINT_LOG_REQUEST',
  GET_POINT_LOG_SUCCESS: 'point/GET_POINT_LOG_SUCCESS',
  getPointLogList: createAction('point/GET_POINT_LOG_REQUEST'),

  /**
   * [포인트 일괄 발급] 엑셀 일괄 발급 유효성 체크 요청하기
   */
  EXCEL_BULK_GENERATE_POINT_CHECK_REQUEST: 'point/EXCEL_BULK_GENERATE_POINT_CHECK_REQUEST',
  excelBulkGeneratePointCheck: createAction('point/EXCEL_BULK_GENERATE_POINT_CHECK_REQUEST'),

  /**
   * [포인트 발급] 포인트 발급받을 유저 리스트 엑셀 다운로드 요청하기
   */
  GET_GENERATE_POINT_USER_LIST_EXCEL_DOWNLOAD_REQUEST: 'point/GET_GENERATE_POINT_USER_LIST_EXCEL_DOWNLOAD_REQUEST',
  getGeneratePointUserListExcelDownload: createAction('point/GET_GENERATE_POINT_USER_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   *  [포인트 랭킹] 포인트 랭킹 리스트 엑셀 다운로드 요청하기
   */
  GET_POINT_RANKING_LIST_EXCEL_DOWNLOAD_REQUEST: 'point/GET_POINT_RANKING_LIST_EXCEL_DOWNLOAD_REQUEST',
  getPointRankingListExcelDownload: createAction('point/GET_POINT_RANKING_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [포인트 발급 내역 리스트] 포인트 발급 내역 리스트 가져오기
   */
  GET_POINT_ISSUE_HISTORY_LIST_REQUEST: 'point/GET_POINT_ISSUE_HISTORY_LIST_REQUEST',
  GET_POINT_ISSUE_HISTORY_LIST_SUCCESS: 'point/GET_POINT_ISSUE_HISTORY_LIST_SUCCESS',
  getPointIssueHistoryList: createAction('point/GET_POINT_ISSUE_HISTORY_LIST_REQUEST'),

  /**
   * [포인트 발급 내역 상세] 포인트 발급 내역 상세 가져오기
   */
  GET_POINT_ISSUE_HISTORY_DETAIL_REQUEST: 'point/GET_POINT_ISSUE_HISTORY_DETAIL_REQUEST',
  GET_POINT_ISSUE_HISTORY_DETAIL_SUCCESS: 'point/GET_POINT_ISSUE_HISTORY_DETAIL_SUCCESS',
  getPointIssueHistoryDetail: createAction('point/GET_POINT_ISSUE_HISTORY_DETAIL_REQUEST'),

  /**
   *  [포인트 발급 내역 상세] 포인트 로그 리스트 가져오기
   */
  GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_REQUEST: 'point/GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_REQUEST',
  GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_SUCCESS: 'point/GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_SUCCESS',
  getPointIssueHistoryPointLogList: createAction('point/GET_POINT_ISSUE_HISTORY_POINT_LOG_LIST_REQUEST'),

  /**
   *  [레퍼럴 발급 현황] 레퍼럴 발급 리스트 가져오기
   */
  GET_POINT_REFERRAL_ISSUE_LIST_REQUEST: 'point/GET_POINT_REFERRAL_ISSUE_LIST_REQUEST',
  GET_POINT_REFERRAL_ISSUE_LIST_SUCCESS: 'point/GET_POINT_REFERRAL_ISSUE_LIST_SUCCESS',
  getPointReferralIssueList: createAction('point/GET_POINT_REFERRAL_ISSUE_LIST_REQUEST'),

  /**
   *  [포인트 사유 리스트] 포인트 사유 리스트 가져오기
   */
  GET_POINT_CAUSE_LIST_REQUEST: 'point/GET_POINT_CAUSE_LIST_REQUEST',
  GET_POINT_CAUSE_LIST_SUCCESS: 'point/GET_POINT_CAUSE_LIST_SUCCESS',
  getPointCauseList: createAction('point/GET_POINT_CAUSE_LIST_REQUEST'),

  /**
   *  [포인트 사유 등록] 포인트 사유 등록하기
   */
  CREATE_POINT_CAUSE_REQUEST: 'point/CREATE_POINT_CAUSE_REQUEST',
  createPointCause: createAction('point/CREATE_POINT_CAUSE_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'point/TOGGLE_MODAL',
  toggleModal: createAction('point/TOGGLE_MODAL'),

  /**
   * [포인트 발급 모달] 포인트 발급 하기
   */
  GENERATE_POINT_SUCCESS: 'point/GENERATE_POINT_SUCCESS',
};

export default actions;
